import { useEffect, useState, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getPsadRepById } from 'api/psad_reps';

import InvitationsCard from 'components/cards/invitations';
import ViewField from 'components/view_field/view_field';

import Loading from 'components/loading/loading';

const PsadRepItem = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const { id } = useParams();
  const history = useHistory();

  const fetchData = useCallback(async () => {
    setLoading(true);
    const data = await getPsadRepById(id);
    setData(data);
    setLoading(false);
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading || !data) return <Loading />;

  return (
    <main className="th-main">
      <section className="th-canvas">
        <section className="view-container">
          <div className="flex items-center mb10 bt b--lightgrey-d1 pt8">
            <div>
              <h3 className="f2 fw6 ma0 pa0">
                {data.firstName} {data.lastName}
              </h3>
              <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">
                {data.email}
              </p>
            </div>
            <section className="view-actions" style={{ marginLeft: 'auto' }}>
              <button
                className="btn-green"
                data-cy="edit"
                onClick={() => history.push(`/psad_reps/${id}/edit`)}
              >
                <span>Edit</span>
              </button>
            </section>
          </div>

          <div className="flex flex-column items-center mb10 pt8">
            <div className="w-100 flex flex-column items-start justify-between">
              <ViewField
                label="Treating organisation"
                value={data.treatingOrg?.name}
              />
            </div>
            <div className="w-100 flex flex-column items-start justify-between">
              <ViewField label="Phone number" value={data.phone} />
            </div>
            <InvitationsCard data={data.invitations} />
          </div>
        </section>
      </section>
    </main>
  );
};

export default PsadRepItem;
